declare global {
  interface Window {
    fbq: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue: unknown[]
      loaded: boolean
      version: string
      push: (...args: unknown[]) => void
    }
    _fbq: typeof window.fbq
  }
}

const PIXEL_ID = '1214564297436727'

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: Window['fbq'] = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args)
    } else {
      n.queue.push(args)
    }
  } as Window['fbq']

  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  window.fbq = n
  if (!window._fbq) window._fbq = n

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Also add noscript fallback img
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
